import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { organizationActions } from "_actions";
import _ from "lodash";
import { OrganizationBuilder } from "../objects/OrganizationBuilder";

export default function useOrganizations(visibility = ['PUBLIC', 'FEATURED']) {
    const dispatch = useDispatch();

    const organizationsObj = useSelector(state => state.organizations);
    const loading = organizationsObj.loading;
    const organizationObjList = _.get(organizationsObj.organizations, 'organizations') || [];

    useEffect(() => {
        const hasOrganizations = organizationObjList.length > 0;
        if (!hasOrganizations && !loading) {
            dispatch(organizationActions.getAll({ visibility }));
        }
    }, [organizationObjList, loading, dispatch, visibility]);

    const organizations = useMemo(() => {
        if (!loading && organizationObjList.length > 0) {
            return organizationObjList.map(organization => {
                const builder = new OrganizationBuilder();
                builder.setId(_.get(organization, 'id') || '-');
                builder.setValue(_.get(organization, 'id') || '-');
                builder.setName(_.get(organization, 'name') || '-');
                return builder.organization;
            });
        }
        return [];
    }, [organizationObjList, loading]);

    return { organizations, loading };
}